<section class="page__header">
    <custom-app-bar
            [hasCloseButton]="true"
            [title]="'share_products.title' | translate"
            [hasSafeArea]="false"
    ></custom-app-bar>
</section>

<section class="page__content">
    <div class="list-header">
        <custom-checkbox
            [checked]="(allProductsSelected$ | async) ?? false"
            labelPosition="left"
            (change)="handleOnSelectAllChange($event)"
        >
           <span>{{ 'share_products.select_all_checkbox_label' | translate }}</span>
        </custom-checkbox>
    </div>
    @for (shareableProduct of shareableProducts$ | async; track shareableProduct.code) {
        <ep-product-list-tile
                [product]="shareableProduct.product"
                [hasAddToListButton]="false"
                [hasDeleteButton]="false"
                [hasAddToCartButton]="false"
                [isNavigateToProductEnabled]="false"
                [isLabelsEnabled]="false"
        >
            <custom-checkbox
                    actions
                    [checked]="shareableProduct.selected"
                    (change)="handleOnSelectProductChange($event, shareableProduct)"
            ></custom-checkbox>
        </ep-product-list-tile>
    }
</section>

<section class="page__footer">
    @if (areSelectedProductsGreaterThanMax$ | async) {
        <div>
            {{'share_products.selection_limit_exceeded' | translate: {exceeded_quantity: exceededSelectedProductsCount$ | async} }}
        </div>
    }
    <button
            customButton
            [isLoading]="isProductsSharingLoading$ | async"
            [disabled]="!(canShareProducts$ | async)"
            size="large"
            expand="full"
            (click)="shareSelectedProducts()"
    >
        {{ "share_products.share_button_label" | translate }}
    </button>
</section>